export const uk = {
    'audio-url': 'Ссылка на аудио',
    cancel: 'Отменить',
    'image-url': 'Ссылка на изображение',
    upload: 'Загрузить',
    'video-url': 'Ссылка на видео'
};
